import { defineComponent as _defineComponent } from 'vue'
import TooltipButton from '@/components/TooltipButton.vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckboxButton',
  props: {
  checked: {
    type: Boolean,
    default: false,
  },
  variant: {
    type: String,
    default: 'outline-secondary',
  },
  type: {
    type: String,
    default: '',
  },
  tooltipText: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props

// define props and emits


const checkboxTypeClass = computed(() => {
  if (props.type === 'accept') {
    return 'checkbox-button__checkbox-accept'
  }
  if (props.type === 'decline') {
    return 'checkbox-button__checkbox-decline'
  }
  return ''
})

return { __sfc: true,props, checkboxTypeClass, TooltipButton }
}

})